import { render, staticRenderFns } from "./assetdepr_adjust.vue?vue&type=template&id=ecda4d58"
import script from "./assetdepr_adjust.vue?vue&type=script&lang=js"
export * from "./assetdepr_adjust.vue?vue&type=script&lang=js"
import style0 from "./assetdepr_adjust.vue?vue&type=style&index=0&id=ecda4d58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports